import Link from 'next/link';

import IconLogo from '@/app/_images/ico_gpk.svg';
import styles from './Logo.module.scss';
import { ROUTER_PATH } from '@/app/_contants/routerPath';
const Logo = ({ ...props }) => {
  const containerClassName = `${styles.logo}${props.className ? ' ' + props.className : ''}`;
  return (
    <Link href={ROUTER_PATH.MAIN} className={containerClassName}>
      <IconLogo height={30} />
    </Link>
  );
};

export default Logo;
